/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useState, useEffect } from 'react';
import { usePlayFlag } from './../../components/topicScroll';

import './conversation.mobile.less';

import ImgConversationLeft from '../../../../../assets/conversation-left.png';
import ImgConversationRight from '../../../../../assets/conversation-right.png';
import useIntersectionObserver from '../../../../../hooks/useIntersectionObserver';

interface IConversationProps {
  message1: string | React.ReactNode;
  message2: string | React.ReactNode;
  avater1?: string;
  avater2?: string;
  className?: string;
  style?: any;
}

const Conversation: React.FunctionComponent<IConversationProps> = ({
  avater1,
  avater2,
  message1,
  message2,
  className,
  style,
}) => {
  const [conversation, setConversation] = React.useState(0);
  // const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const { targetRef, isVisible } = useIntersectionObserver({
    threshold: 0.5, // 元素 30% 进入视口时触发
    rootMargin: '-50px', // 根边距缩小 50px（需元素进入视口 50px 后才判定）
  });
  const playFlag = usePlayFlag(
    targetRef.current as HTMLElement,
    '.course-body'
  );
  // 存储当前缩放比例（百分比形式，如 100 = 100%，150 = 150%）
  const [zoomRatio, setZoomRatio] = useState<number>(100);
  // 防抖定时器（避免频繁触发计算）
  const [debounceTimer, setDebounceTimer] = useState<any>(null);
  const calculateZoomRatio = useCallback(() => {
    try {
      // 1. 获取视口宽度（用 getBoundingClientRect 避免滚动条干扰，比 clientWidth 更精准）
      const viewportRect = document.documentElement.getBoundingClientRect();
      const viewportWidth = viewportRect.width; // 视口宽度（缩放后的值）

      // 2. 获取屏幕宽度（设备物理屏幕宽度，不受缩放影响，作为基准）
      const screenWidth = window.screen.width;

      // 3. 兼容性判断：避免极端情况（如无 DOM 环境、宽度为 0）导致计算错误
      if (viewportWidth <= 0 || screenWidth <= 0) {
        console.warn('无法获取有效宽度，默认缩放比例 100%');
        setZoomRatio(100);
        return;
      }

      // 4. 计算缩放比例（转百分比并取整，避免小数）
      const rawRatio = (screenWidth / viewportWidth) * 100;
      const roundedRatio = Math.round(rawRatio); // 四舍五入（如 149.6 → 150）

      // 5. 更新状态（仅当比例变化时更新，减少重渲染）
      if (roundedRatio !== zoomRatio) {
        setZoomRatio(roundedRatio);
      }
    } catch (error) {
      // 错误捕获：防止 DOM 操作异常影响组件
      console.error('计算缩放比例失败：', error);
      setZoomRatio(100);
    }
  }, [zoomRatio]); // 依赖 zoomRatio，确保比例变化时触发更新
  useEffect(() => {
    // 1. 组件挂载后立即计算初始缩放比例
    calculateZoomRatio();

    // 2. 定义 resize 事件处理函数（带防抖）
    const handleResize = () => {
      // 清除之前的防抖定时器
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
      // 100ms 防抖：用户停止操作后再计算，减少性能消耗
      const newTimer = setTimeout(() => {
        calculateZoomRatio();
      }, 100);
      setDebounceTimer(newTimer);
    };

    // 3. 添加事件监听
    window.addEventListener('resize', handleResize);

    // 4. 组件卸载时清理（避免内存泄漏）
    return () => {
      window.removeEventListener('resize', handleResize);
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
    };
  }, [calculateZoomRatio, debounceTimer]);
  useEffect(() => {
    console.log(isVisible, '====isVisible');
    if (isVisible) {
      setConversation(0);
      setTimeout(() => {
        setConversation(1);
      }, 500);
      setTimeout(() => {
        setConversation(2);
      }, 1500);
    }
  }, [isVisible]);

  return (
    <div
      ref={targetRef}
      style={{ ...style, zoom: zoomRatio / 100 }}
      className={`conversation component ${className}`}
    >
      <div className="conversation-line1">
        <img className="avater" src={avater1} alt="" />
        <div
          className={`conversation-message animation ${
            conversation >= 1 ? 'fade-in' : ''
          }`}
        >
          <img
            className="conversation-message-bg"
            src={ImgConversationLeft}
            alt=""
          />
          {typeof message1 === 'string' ? (
            <div
              className="conversation-message-text"
              dangerouslySetInnerHTML={{ __html: message1 }}
            />
          ) : (
            <div className="conversation-message-text">{message1}</div>
          )}
        </div>
      </div>
      <div className="conversation-line2">
        <img className="avater" src={avater2} alt="" />
        <div
          className={`conversation-message animation ${
            conversation >= 2 ? 'fade-in' : ''
          }`}
        >
          <img
            className="conversation-message-bg"
            src={ImgConversationRight}
            alt=""
          />
          {typeof message2 === 'string' ? (
            <div
              className="conversation-message-text"
              dangerouslySetInnerHTML={{ __html: message2 }}
            />
          ) : (
            <div className="conversation-message-text">{message2}</div>
          )}
        </div>
      </div>
    </div>
  );
};

Conversation.defaultProps = {
  className: '',
  style: {},
  avater1: require(`../../../../../assets/avater6.png`).default,
  avater2: require(`../../../../../assets/avater7.png`).default,
};

export default Conversation;
